<template>
  <div class="admin-categories">
    <header-title title="Rutas de impresión"></header-title>

    <div class="category-btn">
      <v-btn
        dense
        outlined
        @click="openDialog()"
        :style="adminNavigationBackTheme"
      >
        + Nuevo
      </v-btn>
    </div>

    <v-container fluid class="pl-0 pr-0">
      <v-row justify="center">
        <v-col cols="12" sm="6" md="3" lg="2">
          <v-text-field
            outlined
            dense
            label="Buscar"
            v-model="search"
            class="select-box"
            prepend-inner-icon="mdi-magnify"
          ></v-text-field>
        </v-col>
      </v-row>
    </v-container>

    <v-row>
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="typeOrders"
          class="elevation-1 payments-table"
          :search="search"
          :footer-props="{
            'items-per-page-options': [50, 100, 150, -1]
          }"
          :items-per-page="50"
          no-data-text="No se han encontrado resultados !"
        >
          <template v-slot:[`item.group_order_id`]="{ item }">
            <div style="display:flex;">
              <v-btn rounded color="blue-grey" dark :x-small="true"
                >{{ getGroupOrderName(item.group_order_id) }}
              </v-btn>
            </div>
          </template>
          <template v-slot:[`item.editAction`]="{ item }">
            <v-icon small class="mr-2" @click="openDialog(item)">
              mdi-pencil
            </v-icon>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <Loader :dialog-loader="dialogLoader" message="Cargando..."></Loader>

    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <div class="admin-add-products fullheight">
        <v-toolbar dark :color="'#9e9e9e'">
          <v-btn icon dark @click="closeDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>
            <h1
              class="header-tittle"
              :style="{ color: colorsGeneralSecondary }"
            >
              {{
                selectedTypeOrder
                  ? "Editar Rutas de impresión"
                  : "Crear Rutas de impresión"
              }}
            </h1>
          </v-toolbar-title>
        </v-toolbar>
        <v-container fluid>
          <v-form ref="form" lazy-validation @submit.prevent="submit">
            <v-row>
              <v-col cols="12" sm="2" class="py-0 py-sm-1">
                <v-subheader
                  :style="{ color: formLabelTheme }"
                  class="px-sm-1 px-0"
                  >Nombre :</v-subheader
                >
              </v-col>
              <v-col cols="12" sm="9" class="py-0 py-sm-1">
                <v-text-field
                  v-model.trim="input.name"
                  :rules="validationRules.name"
                  required
                  placeholder="E.g. Bebidas"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="2" class="py-0 py-sm-1">
                <v-subheader
                  :style="{ color: formLabelTheme }"
                  class="px-sm-1 px-0"
                  >Grupo de pedido :</v-subheader
                >
              </v-col>
              <v-col cols="12" sm="9" class="py-0 py-sm-1">
                <v-select
                  v-model="input.group_order_id"
                  :items="groupOrders"
                  item-text="name"
                  item-value="id"
                  :rules="validationRules.groupOrderId"
                  label="Selecciona un grupo de Pedido"
                ></v-select>
              </v-col>
            </v-row>

            <v-row>
              <v-col align="center">
                <div class="my-2 mr-5">
                  <v-btn
                    type="submit"
                    dense
                    outlined
                    :style="adminNavigationBackTheme"
                  >
                    Guardar
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";
import Loader from "@/components/common/Loader";
import HeaderTitle from "@/components/admin/common/HeaderTitle.vue";
import { PrintingRouteTableHeader } from "@/utils/tableHeaderconstants";
import { groupOrdersCollection } from "@/collections/groupOrders";
import {
  saveTypeOrder,
  typeOrdersCollection,
  updateTypeOrder
} from "@/collections/typeOrders";

// eslint-disable-next-line no-unused-vars
let fromRoute = undefined;
export default {
  name: "PrintingRoute",
  components: {
    Loader,
    HeaderTitle
  },
  data() {
    return {
      search: "",
      headers: [...PrintingRouteTableHeader],
      groupOrders: [],
      typeOrders: [],
      dialog: false,
      selectedTypeOrder: null,
      isValid: false,
      input: {
        name: null,
        group_order_id: null
      },
      validationRules: {
        name: [v => (!!v && !!v.trim()) || "Nombre es requerido"],
        groupOrderId: [
          v => (!!v && !!v.trim()) || "Grupo de pedido es requerido"
        ]
      },
      dialogLoader: false
    };
  },
  firestore() {
    return {
      groupOrders: groupOrdersCollection,
      typeOrders: typeOrdersCollection
    };
  },
  methods: {
    getGroupOrderName(groupOrderId) {
      let groupOrder = this.groupOrders.find(x => x.id === groupOrderId);
      return groupOrder ? groupOrder.name : "";
    },
    async submit() {
      if (this.$refs.form.validate()) {
        try {
          if (this.selectedTypeOrder) {
            // check update unique name
            let found = this.typeOrders.some(
              x =>
                x.name.toLowerCase().trim() ===
                  this.input.name.toLowerCase().trim() && x.id !== this.itemId
            );
            if (found) {
              this.showErrorMessage("El nombre debe ser único");
              return;
            }
            // update
            await updateTypeOrder(this.selectedTypeOrder.id, this.buildJson());
            this.dialog = false;
          } else {
            let found = this.typeOrders.some(
              x =>
                x.name.toLowerCase().trim() ===
                this.input.name.toLowerCase().trim()
            );
            if (found) {
              this.showErrorMessage("El nombre debe ser único");
              return;
            }

            // create
            await saveTypeOrder(this.buildJson());
            this.dialog = false;
          }
        } catch (error) {
          this.setlogError(
            "save_type_order",
            "Obtained error message in submit()",
            error.stack,
            this.$options.name
          );
          this.dialog = false;
        }
      }
    },
    buildJson() {
      let now = moment().format();
      return { ...this.input, updated_on: now };
    },
    openDialog(typeOrder) {
      this.selectedTypeOrder = typeOrder;
      if (typeOrder) {
        this.input = { ...typeOrder };
      }
      this.dialog = true;
    },
    closeDialog() {
      this.selectedTypeOrder = null;
      this.$refs.form.reset();
      this.dialog = false;
    }
  },
  mounted() {
    setTimeout(() => {}, 2000);
  },
  beforeRouteEnter(to, from, next) {
    fromRoute = from;
    next();
  }
};
</script>
<style scoped lang="scss">
.admin-categories {
  height: calc(100vh - 63px);
}
.table-scroll {
  max-width: 100%;
  overflow-x: auto;
}
</style>
